import { queryOptions, useQuery } from '@tanstack/react-query';
import { type PrivacySettings, privacySettingsScheme } from '@/models/mine/privacy-settings';
import { generateResponseScheme, type RespondedWith } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

export const privacySettingQueryOptions = queryOptions({
  queryKey: ['/GetVerifiedFriendSetting'],
  queryFn: ({ signal }) =>
    fetcher<RespondedWith<PrivacySettings>>('/GetVerifiedFriendSetting', undefined, {
      signal,
      schema: generateResponseScheme(privacySettingsScheme),
      validResponseCodes: [0],
    }).then((response) => response.Data ?? null),
  staleTime: 0,
  refetchOnWindowFocus: 'always',
});

export default function usePrivacySettings() {
  return useQuery(privacySettingQueryOptions);
}
